// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';

import type {
  IAuthModel,
  TCompleteAuthRequest,
  TCompleteAuthResponse,
  TLoginPayload,
} from '~/misc/auth/types';

// Models
import { DefaultResource } from '~/misc/resource/default-resource.model';

export class AuthModel extends DefaultResource implements IAuthModel {
  protected endpoint = 'user/';

  complete(
    payload: TCompleteAuthRequest,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TCompleteAuthResponse> {
    return this.post<TCompleteAuthResponse>('login/process', payload, requestConfig);
  }

  login(payload: TLoginPayload, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.post<void>('login/request', payload, requestConfig);
  }

  logout(): Promise<void> {
    return this.post<void>('logout');
  }
}
